import React from 'react';
import { Grid, Paper, Box, Typography, Skeleton, useTheme } from '@mui/material';
import {
  People as PeopleIcon,
  Login as LoginIcon,
  Logout as LogoutIcon,
  AccessTime as AccessTimeIcon,
} from '@mui/icons-material';

export default function AsistenciaLaboralStats({ stats, loading }) {
  const theme = useTheme();

  const cards = [
    {
      title: 'Total de Registros Hoy',
      value: stats?.total_registros || 0,
      icon: <AccessTimeIcon sx={{ fontSize: { xs: 26, sm: 30 }, color: 'info.main' }} />,
      bg: 'linear-gradient(135deg, rgba(28, 124, 213, 0.08) 0%, rgba(28, 124, 213, 0.16) 100%)',
      borderColor: 'info.main',
      color: 'info.main',
    },
    {
      title: 'Personas registradas hoy',
      value: stats?.total_trabajadores || 0,
      icon: <PeopleIcon sx={{ fontSize: { xs: 26, sm: 30 }, color: 'secondary.main' }} />,
      bg: 'linear-gradient(135deg, rgba(0, 69, 130, 0.08) 0%, rgba(0, 69, 130, 0.16) 100%)',
      borderColor: 'secondary.main',
      color: 'secondary.main',
    },
    {
      title: 'Entradas Registradas',
      value: stats?.total_entradas || 0,
      icon: <LoginIcon sx={{ fontSize: { xs: 26, sm: 30 }, color: 'success.main' }} />,
      bg: 'linear-gradient(135deg, rgba(50, 164, 48, 0.08) 0%, rgba(50, 164, 48, 0.16) 100%)',
      borderColor: 'success.main',
      color: 'success.main',
    },
    {
      title: 'Salidas Registradas',
      value: stats?.total_salidas || 0,
      icon: <LogoutIcon sx={{ fontSize: { xs: 26, sm: 30 }, color: 'warning.main' }} />,
      bg: 'linear-gradient(135deg, rgba(238, 152, 0, 0.08) 0%, rgba(238, 152, 0, 0.16) 100%)',
      borderColor: 'warning.main',
      color: 'warning.main',
    },
  ];

  return (
    <Grid container spacing={{ xs: 1.5, sm: 2.5 }} sx={{ mb: { xs: 2.5, sm: 3.5 } }}>
      {cards.map((card, idx) => (
        <Grid item xs={6} sm={6} md={3} key={idx}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 1.75, sm: 2.25 },
              borderRadius: '18px',
              background: card.bg,
              border: '1px solid',
              borderColor: card.borderColor,
              boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
              transition: 'transform 0.2s ease, box-shadow 0.2s ease',
              '&:hover': {
                transform: 'translateY(-3px)',
                boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
              },
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: 700,
                  color: card.color,
                  textTransform: 'uppercase',
                  letterSpacing: 0.5,
                  fontSize: { xs: '0.68rem', sm: '0.78rem' },
                  lineHeight: 1.2,
                }}
              >
                {card.title}
              </Typography>
              <Box
                sx={{
                  p: { xs: 0.5, sm: 0.8 },
                  borderRadius: '10px',
                  bgcolor: 'common.white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
                }}
              >
                {card.icon}
              </Box>
            </Box>

            {loading ? (
              <Skeleton variant="text" width={60} height={40} />
            ) : (
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 'bold',
                  color: 'text.primary',
                  lineHeight: 1.1,
                  fontSize: { xs: '1.4rem', sm: '1.85rem' },
                }}
              >
                {card.value}
              </Typography>
            )}
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
}
